import { useState, useCallback } from 'react';

import { useHttpClient } from './http-hook';

export const useProduct = () => {
  const [products, setProducts] = useState([]);
  const [totalProducts, setTotalProducts] = useState(0);
  const { sendRequest } = useHttpClient();

  const fetchAllProducts = useCallback(async () => {
    try {
      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/products/client`
      );

      setProducts(responseData.data.data);
      setTotalProducts(responseData.results);
    } catch (err) {}
  }, [sendRequest]);

  return { products, totalProducts, fetchAllProducts };
};
